<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminGroup.searchCondition') }}</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input v-model="adminGroupInfo.conditions.prodName" :placeholder="$t('adminGroup.inputProductName')"
                clearable></el-input>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="_queryProductMethod">{{ $t('adminGroup.search') }}</el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('adminGroup.shopGroup') }}</span>
          </div>
          <el-table :data="adminGroupInfo.groups" border style="width: 100%">
            <el-table-column prop="groupId" :label="$t('adminGroup.id')" align="center" width="80"></el-table-column>
            <el-table-column :label="$t('adminGroup.productImage')" align="center" width="120">
              <template slot-scope="scope">
                <div style="position: relative; display: inline-block;">
                  <img width="50" height="50" style="border-radius: 10px;"
                    :src="scope.row.coverPhoto || '/img/noPhoto.jpg'">
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="prodName" :label="$t('adminGroup.productName')" align="center"></el-table-column>
            <el-table-column prop="userCount" :label="$t('adminGroup.groupPeople')" align="center"
              width="100"></el-table-column>
            <el-table-column prop="groupPrice" :label="$t('adminGroup.groupPrice')" align="center" width="120">
              <template slot-scope="scope">￥{{ scope.row.groupPrice }}</template>
            </el-table-column>
            <el-table-column prop="price" :label="$t('adminGroup.singlePrice')" align="center" width="120">
              <template slot-scope="scope">￥{{ scope.row.price }}</template>
            </el-table-column>
            <el-table-column prop="state" :label="$t('adminGroup.status')" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.state == '1001' ? $t('adminGroup.enable') :
                $t('adminGroup.disable')}}</template>
            </el-table-column>
            <el-table-column :label="$t('adminGroup.validity')" align="center" width="200">
              <template slot-scope="scope">{{ scope.row.startTime }}~{{ scope.row.endTime }}</template>
            </el-table-column>
            <el-table-column prop="rebateFlag" :label="$t('adminGroup.isRebate')" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.rebateFlag == 'Y' ? $t('adminGroup.yes') :
                $t('adminGroup.no')}}</template>
            </el-table-column>
            <el-table-column prop="rebate" :label="$t('adminGroup.leaderRebate')" align="center" width="100">
              <template slot-scope="scope">{{ scope.row.rebate }}%</template>
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="adminGroupInfo.conditions.page"
            :page-size="adminGroupInfo.conditions.row" layout="total, prev, pager, next" :total="adminGroupInfo.total"
            style="margin-top: 20px; text-align: right;"></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <delete-product ref="deleteProduct"></delete-product>
  </div>
</template>

<script>
import { listAdminProductGroup } from '@/api/group/adminGroupApi'
import AdminShop from '@/components/shop/adminShop'
import DeleteProduct from '@/components/admin/deleteProduct/deleteProduct'
import { getShopId } from '@/api/shop/shopApi'

export default {
  components: {
    AdminShop,
    DeleteProduct
  },
  data() {
    return {
      adminGroupInfo: {
        groups: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          categoryId: '',
          prodName: '',
          keyword: '',
          barCode: '',
          shopId: ''
        }
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this._listAdminGroups()
  },
  methods: {
    handleShopChange(shop) {
      this.adminGroupInfo.conditions.shopId = shop.shopId
      this._listAdminGroups()
    },
    handleCurrentChange(currentPage) {
      this.adminGroupInfo.conditions.page = currentPage
      this._listAdminGroups()
    },
    _listAdminGroups() {
      const params = {
        ...this.adminGroupInfo.conditions,
        shopId: this.shopId
      }

      listAdminProductGroup(params).then(res => {
        this.adminGroupInfo.groups = res.data
        this.adminGroupInfo.total = res.total
        this.adminGroupInfo.records = res.records
        console.log(this.adminGroupInfo.records)
      }).catch(error => {
        console.error('获取拼团列表失败:', error)
      })
    },
    _queryProductMethod() {
      this.adminGroupInfo.conditions.page = 1
      this._listAdminGroups()
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}
</style>